import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { faFileCode, faFilePdf, faLink } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'antd';
import fileDownload from 'js-file-download';
import PropTypes from 'prop-types';
import React from 'react';
import {
  downloadNextSiDanfe,
  downloadNextSiInvoice,
  downloadNextSiXml,
} from '../../../services/repository/payrollRepository';
import { handleFileDownload } from '../../../services/util/file';
import mostrarErro from '../../../services/util/error-handler';

function InvoiceDownloadLine({ invoice, payrollId }) {
  const { nomeCliente, tipo, id, nfeLink, docDisponivel, xmlDisponivel, danfeDisponivel, emissao } = invoice;
  const canDownloadInvoice = docDisponivel;
  const canLink = nfeLink && canDownloadInvoice;
  const canDownloadDanfe = danfeDisponivel;
  const canDownloadXml = xmlDisponivel;
  const emissaoFormated = emissao.format('DD/MM/YYYY');

  const clickLink = () => {
    if (!canLink) return;
    window.open(nfeLink, '_target');
  };

  const handleDownloadInvoice = async () => {
    try {
      if (!canDownloadInvoice) return;
      const { nextSiId } = invoice;
      const invoiceStream = await downloadNextSiInvoice(payrollId, nextSiId);
      fileDownload(invoiceStream, `${payrollId}-fatura-${nomeCliente}-${nextSiId}.pdf`);
    } catch (err) {
      mostrarErro(err);
    }
  };

  const handleDownloadDanfe = async () => {
    try {
      if (!canDownloadDanfe) return;
      const { nextSiId } = invoice;
      const invoiceStream = await downloadNextSiDanfe(payrollId, nextSiId);
      fileDownload(invoiceStream, `${payrollId}-danfe-${nomeCliente}-${nextSiId}.pdf`);
    } catch (err) {
      mostrarErro(err);
    }
  };

  const handleDownloadXml = async () => {
    try {
      if (!canDownloadXml) return;
      const { nextSiId } = invoice;
      const invoiceStream = await downloadNextSiXml(payrollId, nextSiId);
      fileDownload(invoiceStream, `${payrollId}-xml-${nomeCliente}-${nextSiId}.xml`);
    } catch (err) {
      mostrarErro(err);
    }
  };

  return (
    <tr>
      <td>
        <CustomText
          ellipsis
          style={{ maxWidth: '580px' }}
        >
          <span title={nomeCliente}>{nomeCliente}</span>
        </CustomText>
      </td>
      <td>
        <CustomText ellipsis>{id}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{emissaoFormated}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{tipo}</CustomText>
      </td>
      <td>
        <Tooltip title="NFE">
          <FontAwesomeIcon
            icon={faLink}
            color={canLink ? '#262626' : '#E4E5E7'}
            style={{ cursor: canLink ? 'pointer' : 'not-allowed' }}
            onClick={clickLink}
            size="lg"
          />
        </Tooltip>
      </td>
      <td>
        <Tooltip title="FATURA">
          <FontAwesomeIcon
            color={canDownloadInvoice ? '#262626' : '#E4E5E7'}
            style={{ cursor: canDownloadInvoice ? 'pointer' : 'not-allowed' }}
            onClick={() => handleFileDownload(handleDownloadInvoice)}
            icon={faFilePdf}
            size="lg"
          />
        </Tooltip>
      </td>
      <td>
        <Tooltip title="DANFE">
          <FontAwesomeIcon
            color={canDownloadDanfe ? '#262626' : '#E4E5E7'}
            style={{ cursor: canDownloadDanfe ? 'pointer' : 'not-allowed' }}
            onClick={() => handleFileDownload(handleDownloadDanfe)}
            icon={faFilePdf}
            size="lg"
          />
        </Tooltip>
      </td>
      <td>
        <Tooltip title="XML">
          <FontAwesomeIcon
            color={canDownloadXml ? '#262626' : '#E4E5E7'}
            style={{ cursor: canDownloadXml ? 'pointer' : 'not-allowed' }}
            onClick={() => handleFileDownload(handleDownloadXml)}
            icon={faFileCode}
            size="lg"
          />
        </Tooltip>
      </td>
    </tr>
  );
}

InvoiceDownloadLine.propTypes = {
  invoice: PropTypes.shape(),
  payrollId: PropTypes.string.isRequired,
};

InvoiceDownloadLine.defaultProps = {
  invoice: {},
};

export default InvoiceDownloadLine;
